import { render } from "./VtoSwitcher.vue?vue&type=template&id=10c978df"
import script from "./VtoSwitcher.vue?vue&type=script&lang=js"
export * from "./VtoSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__